import Actions from 'flow/actions';
import { Dispatch } from 'redux';
import WebclientKeyboardShortcutResource from 'flow/api/webclientkeyboardshortcut';
import { KeyboardShortcut } from 'flow/types/KeyboardShortcut';

interface KeyboardShortcutsResponse {
    accountId: string;
    shortcuts: KeyboardShortcut[];
}

export const fetchKeyboardShortcuts =
    () =>
    (dispatch: Dispatch<any>): Promise<void> => {
        return new Promise((resolve, reject) => {
            WebclientKeyboardShortcutResource.getKeyboardShortcuts({
                onResult: (response: KeyboardShortcutsResponse) => {
                    dispatch({
                        type: Actions.RESULT_KEYBOARD_SHORTCUTS,
                        data: response.shortcuts,
                    });
                    resolve();
                },
                onError: (error: any) => {
                    console.error(
                        'Shortcut: Error fetching keyboard shortcuts:',
                        error,
                    );
                    reject(error);
                },
            });
        });
    };

export const updateKeyboardShortcuts =
    (shortcut: KeyboardShortcut) =>
    (dispatch: Dispatch<any>): Promise<void> =>
        new Promise((resolve, reject) => {
            WebclientKeyboardShortcutResource.updateKeyboardShortcuts(
                {
                    onResult(response: KeyboardShortcutsResponse) {
                        dispatch({
                            type: Actions.RESULT_KEYBOARD_SHORTCUTS,
                            data: response.shortcuts,
                        });
                        resolve();
                    },
                    onError() {
                        reject();
                    },
                },
                {
                    keyboardShortcutId: shortcut.keyboardShortcutEntityId,
                    enabled: shortcut.enabled,
                    value: shortcut.value,
                },
            );
        });
